import { useMemo } from 'react'
import { useUserContext } from '@vp/ubik-context'
import { FEATURE_GATES } from 'shared/featureGates/constants'
import { isFeatureGateEnabled, parseForcedFeatureGates } from 'shared/featureGates'

export const useFeatureGate = (gate: FEATURE_GATES): boolean => {
  const { featureFlags, queryStrings } = useUserContext()

  return useMemo(() => {
    const forced = parseForcedFeatureGates(queryStrings?.['forceFeatureGate'])
    // Precedence: explicit force-off > explicit force-on > Statsig rollout.
    // force-off lets tests/QA pin a gate disabled regardless of the staged rollout.
    if (forced.off.has(gate)) {
      return false
    }
    if (forced.on.has(gate)) {
      return true
    }
    return isFeatureGateEnabled(featureFlags, gate)
  }, [featureFlags, queryStrings, gate])
}
